const SLUG_REPLACEMENTS = {
  a: /[ąàáâãäå]/g,
  c: /[ćç]/g,
  e: /[ęèéêë]/g,
  l: /[ł]/g,
  n: /[ńñ]/g,
  o: /[óòôõö]/g,
  s: /[śß]/g,
  z: /[źż]/g,
};

const BOOKING_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function getCurrentHostname() {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location.hostname;
}

export function isLandingHost(hostname = getCurrentHostname()) {
  return hostname === 'clientway.pl' || hostname === 'www.clientway.pl';
}

export function isPanelHost(hostname = getCurrentHostname()) {
  return hostname === 'app.clientway.pl';
}

export function normalizeBookingSlug(value) {
  let normalized = String(value || '').trim().toLowerCase();

  Object.entries(SLUG_REPLACEMENTS).forEach(([replacement, pattern]) => {
    normalized = normalized.replace(pattern, replacement);
  });

  normalized = normalized
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-')
    .slice(0, 50)
    .replace(/-+$/g, '');

  return normalized;
}

export function isBookingSlugValid(value) {
  const normalized = normalizeBookingSlug(value);
  return normalized.length >= 3 && normalized.length <= 50 && BOOKING_SLUG_PATTERN.test(normalized);
}

export function resolveBookingOrigin() {
  if (typeof window === 'undefined') {
    return 'https://clientway.pl';
  }

  const { hostname, origin } = window.location;

  if (hostname === 'app.clientway.pl' || hostname === 'www.clientway.pl') {
    return 'https://clientway.pl';
  }

  return origin;
}

export function resolvePanelLoginUrl() {
  if (typeof window === 'undefined') {
    return 'https://app.clientway.pl/login';
  }

  const { hostname, origin } = window.location;

  if (hostname === 'clientway.pl' || hostname === 'www.clientway.pl') {
    return 'https://app.clientway.pl/login';
  }

  return `${origin}/login`;
}

export function resolvePanelRegisterUrl() {
  if (typeof window === 'undefined') {
    return 'https://app.clientway.pl/register';
  }

  const { hostname, origin } = window.location;

  if (hostname === 'clientway.pl' || hostname === 'www.clientway.pl') {
    return 'https://app.clientway.pl/register';
  }

  return `${origin}/register`;
}

export function resolveAdminLoginUrl() {
  if (typeof window === 'undefined') {
    return 'https://app.clientway.pl/admin/login';
  }

  const { hostname, origin } = window.location;

  if (hostname === 'clientway.pl' || hostname === 'www.clientway.pl') {
    return 'https://app.clientway.pl/admin/login';
  }

  return `${origin}/admin/login`;
}

export function resolvePanelOrigin() {
  if (typeof window === 'undefined') {
    return 'https://app.clientway.pl';
  }

  if (isLandingHost(window.location.hostname)) {
    return 'https://app.clientway.pl';
  }

  return window.location.origin;
}

export function resolveLandingOrigin() {
  if (typeof window === 'undefined') {
    return 'https://clientway.pl';
  }

  if (isPanelHost(window.location.hostname)) {
    return 'https://clientway.pl';
  }

  return window.location.origin;
}

export function buildPublicBookingUrl(bookingSlug) {
  const normalizedSlug = normalizeBookingSlug(bookingSlug);
  const bookingOrigin = resolveBookingOrigin();
  return normalizedSlug ? `${bookingOrigin}/book/${normalizedSlug}` : `${bookingOrigin}/book`;
}